import React, { useState } from "react";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./mobileSlider.module.css";
import { Card, Col, Row } from "antd";
import { JoinSection } from "@/interfaces/site-settings.interface";
import Image from "next/image";
import { $publicImages } from "@/utils/client";

type SliderProps = {
  data: JoinSection;
};

const SimpleSlider: React.FC<SliderProps> = ({ data }) => {
  const [settings] = useState<Settings>({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  return (
    <div>
      {/* @ts-ignore */}
      <Slider {...settings}>
        {/* @ts-ignore */}
        {data?.cards?.map((item, i) => (
          <Row key={i}>
            <Col md={8}>
              <Card className={`${styles.card}`}>
                <Image
                  src={$publicImages(item.image.path)}
                  width={100}
                  height={100}
                  alt=""
                />

                <h5 className={`${styles.create}`}>{item.title}</h5>
                <p className={`${styles.detail}`}>{item.subtitle}</p>
              </Card>
            </Col>
          </Row>
        ))}
      </Slider>
    </div>
  );
};

export default SimpleSlider;
